const menuToggle = document.querySelector('.site-header__menu-toggle');
const siteNav = document.querySelector('.site-header__nav');

if (menuToggle && siteNav) {
	menuToggle.addEventListener('click', () => {
		const isOpen = document.body.classList.toggle('menu-is-open');

		menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		menuToggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
	});

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' && document.body.classList.contains('menu-is-open')) {
			document.body.classList.remove('menu-is-open');
			menuToggle.setAttribute('aria-expanded', 'false');
			menuToggle.setAttribute('aria-label', 'Open menu');
			menuToggle.focus();
		}
	});
}